export default __webpack_public_path__ + "static/media/What-we-do-Landing page-APICreation&Mgmt.c4fc33f3.png";